import { Injectable, inject, DOCUMENT } from '@angular/core';

import { ExternalScriptService } from './external-script.service';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let FreshWidget: { init: Function };

@Injectable({
    providedIn: 'root',
})
export class FreshWidgetService {
    readonly #document = inject(DOCUMENT);
    readonly #externalScriptService = inject(ExternalScriptService);

    freshWidgetElement!: HTMLElement;

    init(supportInfo?: string) {
        const description = supportInfo ? '<br><br>' + supportInfo : '';
        this.#externalScriptService.load('freshwidget').then(() => {
            FreshWidget.init('', {
                queryString: `&widgetType=popup&formTitle=Support+Request&submitTitle=Submit&submitThanks=Thank+you+for+submitting+a+support+request.+A+Relationship+One+representative+will+contact+you+shortly.&helpdesk_ticket[description]=${description}`,
                utf8: '✓',
                widgetType: 'popup',
                buttonType: 'text',
                buttonText: 'Get Support',
                buttonColor: 'white',
                buttonBg: '#0085CA',
                alignment: '2',
                offset: '163px',
                submitThanks:
                    'Thank you for submitting a support request. A Relationship One representative will contact you shortly.',
                formHeight: '500px',
                url: 'https://relationshipone.freshdesk.com',
                loadOnEvent: 'immediate',
            });
            this.freshWidgetElement = this.#document.getElementById('freshwidget-button')!;
            this.freshWidgetElement.style.visibility = 'visible';
        });
    }

    hide() {
        this.freshWidgetElement.style.visibility = 'hidden';
    }
}
